module.exports = __webpack_public_path__ + "static/media/providerSilverTop2M.acb28a24.webp";